import { useContext } from "react";
import { AppBar, Box, Button, IconButton, Stack, Toolbar, useMediaQuery } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";

import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';

import NotificationBell from "./NotificationBell";
import UserMenu from "./UserMenu";

import SearchStock from "./SearchStock";
import AuthContext from "../context/AuthProvider";

function TopMenu({handleDrawerOpen}) {

	const navigate							= useNavigate()
	const {auth}							= useContext(AuthContext)

	const isSmallScreen 					= useMediaQuery(theme => theme.breakpoints.down('sm'));

	return (
		<div>
		<AppBar sx={{minWidth: '320px'}}>
			<Toolbar>
				<Stack direction={'row'} flex={1} alignItems={'center'}>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						onClick={handleDrawerOpen}
						edge="start"
						>
						<MenuIcon />
					</IconButton>  
					<IconButton
						color="inherit"
						aria-label="open drawer"
						component={NavLink}
						to="/"
						edge="start"
						>
						<HomeIcon />
					</IconButton>
					<img src="/images/system/logo.png" alt="Logo" style={{width: 150, height: 50, marginRight: 8}} />
					{/* <Typography sx={{pr:8}}>Chuumberg Terminal</Typography> */}
				</Stack>

				{ !isSmallScreen && (
					<Box sx={{width:600}}>
						<SearchStock 
							usePlaceHolder
							label="Digite o Ticker ou Nome da Empresa"
							sx={{
								backgroundColor: 'white',
								"& .MuiOutlinedInput-notchedOutline": {
									borderColor: "#3f51b5"
								},
								"&:hover:not(.Mui-focused)": {
									"& .MuiOutlinedInput-notchedOutline": {
									borderColor: "#3f51b5",
									borderWidth: '1px'
									},
								},							
								borderRadius: '4px'
							}}
							onClick={(result) => {
								navigate("/company/"+ result.ticker)
								navigate(0)
							}}
						/>
					</Box>
				)}

				<Stack direction={'row'} justifyContent={'flex-end'} flex={1} alignItems={'center'} spacing={1}>
					{auth?.userId ? (
						<>
							<NotificationBell />
							<UserMenu/>
						</>  
					) : (
						<>
							<Button variant="text" sx={{color: 'white', fontWeight: 'bold'}} href="/login">Login</Button>
							<Button variant="text" sx={{color: 'white', fontWeight: 'bold'}} href="/register">Cadastre-se</Button>
						</>
					)}
				</Stack>
				
			</Toolbar>
		</AppBar>

		</div>
	)
}

export default TopMenu;